import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaigns_data_v2",
  "/engagement/campaigns_data",
];
